import { RequestStatusBadge } from "@/components/common/section-components/badge/RequestStatusBadge";
import "@/components/common/section-components/card/text-elements.css";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { Fragment, ReactNode } from "react";
import { LegalOnboardingDetail } from "../schema/handler-functions";

interface Props {
  detail: LegalOnboardingDetail | null;
}

interface InfoRow {
  label: string;
  value: ReactNode;
}

export const LegalAccountDetailCard = ({ detail }: Props) => {
  const leftRows: InfoRow[] = [
    {
      label: "Titular cuenta:",
      value: (
        <Text className="account-value-label">{detail?.razonSocial ?? "-"}</Text>
      ),
    },
    {
      label: "CUIT/CUIL Cuenta:",
      value: (
        <Text className="account-value-label">{detail?.cuitCuil ?? "-"}</Text>
      ),
    },
    {
      label: "Dirección legal:",
      value: (
        <Text className="account-value-label">
          {detail?.domicilioLegal ?? "-"}
        </Text>
      ),
    },
    {
      label: "Tipo de sociedad:",
      value: (
        <Text className="account-value-label">
          {detail?.tipoSociedad ?? "-"}
        </Text>
      ),
    },
  ];

  const rightRows: InfoRow[] = [
    {
      label: "Actividad principal:",
      value: (
        <Text className="account-value-label">
          {detail?.actividadPrincipal ?? "-"}
        </Text>
      ),
    },
    {
      label: "Mail legal:",
      value: (
        <Text className="account-value-label">{detail?.email ?? "-"}</Text>
      ),
    },
    {
      label: "Dirección comercial:",
      value: (
        <Text className="account-value-label">
          {detail?.domicilioFiscal ?? "-"}
        </Text>
      ),
    },
    {
      label: "Estado:",
      value: <RequestStatusBadge status={detail?.estado} noPaddingY />,
    },
  ];

  return (
    <Flex
      flexDir="column"
      border={`1px solid ${AppColors.WHITE_BORDER_1}`}
      borderRadius="12px"
      paddingBottom="12px"
    >
      <Text
        className="amd-card-title"
        textTransform="uppercase"
        paddingX="24px"
        paddingTop="14px"
        paddingBottom="16px"
      >
        Detalle cuenta jurídica
      </Text>
      <Grid templateColumns="1fr 1fr 1fr 1fr">
        {leftRows.map((leftRow, index) => {
          const rightRow = rightRows[index];
          const backgroundColor =
            index % 2 === 0 ? AppColors.BACKGROUND_SECONDARY : undefined;

          return (
            <Fragment key={leftRow.label}>
              <GridItem
                paddingX="24px"
                paddingY="10px"
                backgroundColor={backgroundColor}
              >
                <Text className="account-title-label">{leftRow.label}</Text>
              </GridItem>
              <GridItem
                paddingX="24px"
                paddingY="10px"
                backgroundColor={backgroundColor}
              >
                {leftRow.value}
              </GridItem>
              <GridItem
                paddingX="24px"
                paddingY="10px"
                backgroundColor={backgroundColor}
              >
                <Text className="account-title-label">{rightRow.label}</Text>
              </GridItem>
              <GridItem
                paddingX="24px"
                paddingY="10px"
                backgroundColor={backgroundColor}
              >
                {rightRow.value}
              </GridItem>
            </Fragment>
          );
        })}
      </Grid>
    </Flex>
  );
};
